import { PropsWithChildren } from "react";

export default function StopClick(props: PropsWithChildren<{}>) {
  return <span onClick={(e) => e.stopPropagation()}>{props.children}</span>;
}
